module.exports = __webpack_public_path__ + "images/flyer-56530e71af3745d19aa552811043906e.svg";